import React, { useState, useContext, useEffect } from 'react';
import InputMask from 'react-input-mask';
import {apiGet, apiPost, getProNameHeader} from '../brainApi';
import { QuickAppointmentContext } from '../Context';
import { getZ3PConfigValue, tracRudderStackEvent, currentPageInfo } from "../helper";

export default function GoogleReviewPopUp({ show, onClose }) {
  const {  note,setNote } = useContext(QuickAppointmentContext);

  const [fields, setFields] = useState({
    email: '',
    phone: '',
    firstName: '',
    lastName: '',
  });

  const [errors, setErrors] = useState({});
  const [focused, setFocused] = useState({
    email: false,
    phone: false,
    firstName: false,
    lastName: false,
  });

  useEffect(() => {
      if (note) {
        setTimeout(() => setNote(null), 3000);
      }
    }, [note, setNote]);
  
    useEffect(() => {
      if (!show) {
        setFields({
          email: '',
          phone: '',
          firstName: '',
          lastName: '',
        });
        setErrors({});
        setFocused({
          email: false,
          phone: false,
          firstName: false,
          lastName: false,
        });
      }
    }, [show]);

  if (!show) return null;

  const validate = () => {
    const newErrors = {};

    // Email validation
    if (!fields.email) {
      newErrors.email = 'Email is required';
    } else if (!/^\S+@\S+\.\S+$/.test(fields.email)) {
      newErrors.email = 'Invalid email format';
    }

    // Phone validation
    const rawPhone = fields.phone.replace(/\D/g, '');
    const phoneWithoutCountry = rawPhone.startsWith('1') ? rawPhone.slice(1) : rawPhone;

    if (!phoneWithoutCountry) {
      newErrors.phone = 'Phone is required';
    } else if (!/^\d{10}$/.test(phoneWithoutCountry)) {
      newErrors.phone = 'Phone must be 10 digits';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFocus = (field) => {
    setFocused({ ...focused, [field]: true });
  };

  const handleBlur = (field) => {
    setFocused({ ...focused, [field]: false });
  };

  const handleChange = (field, value) => {
    setFields({ ...fields, [field]: value });
    setErrors({ ...errors, [field]: undefined });
  };

  const cleanedPhone = fields.phone.replace(/\D/g, '');
  const validPhone = cleanedPhone.startsWith('1') ? cleanedPhone.slice(1) : cleanedPhone;

  const isFormValid =
    /^\S+@\S+\.\S+$/.test(fields.email) &&
    /^\d{10}$/.test(validPhone);

  const handleSubmit = () => {
    if (validate()) {
      handleSubmitAPI();
      onClose();
    }
  };

  const rudderStackEvent = (data = {}) => {
    tracRudderStackEvent('Review_SMS_requested', {
      proname: getZ3PConfigValue('z3p_client_name'),
      installer_id: getZ3PConfigValue('st_installer_id'),
      customer_email: data.email,
      phone_number: data.phone,
      First_name: data.firstName,
      Last_name: data.lastName,
      withAppointment: false,
      page_information: {
        path: currentPageInfo['PATH'],
        url: currentPageInfo['URL'],
        title: document.title,
      },
    });
  };

  const handleSubmitAPI = () => {
    // const cleanedPhone = fields.phone.replace(/\D/g, '');
    // const finalPhone = cleanedPhone.startsWith('1') ? cleanedPhone.slice(1) : cleanedPhone;
    const body = {
      first_name: fields.firstName,
      last_name: fields.lastName,
      email: fields.email,
      phone: fields.phone,
      send_welcome_email: false,
      send_google_review_sms: true,
    };
    apiGet(`/customer/${fields.email}?send_google_review_sms=true`).then((data) => {
      if (data.status == 405) {
        alert(data.message);
      }
      else if (data && data?.vehicles && data.vehicles.length > 0) {
        rudderStackEvent(fields);
        alert("Message send successfully");
      }
      else if ((data && data?.vehicles && data.vehicles.length == 0) ||
          (data && data.Status == 400)) {
        apiPost('/customer', body)
            .then((response) => {
              rudderStackEvent(fields);
              alert("Message send successfully");
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  };

  const renderFloatingInput = (field, label, placeholder, type = 'text') => {
    const isActive = focused[field] || fields[field];
    const showLabel = isActive;

    return (
      <div style={styles.inputWrapper}>
        {field === 'phone' ? (
          <InputMask
            mask="+1 99999-99999"
            maskChar={null}
            value={fields.phone}
            onChange={(e) => handleChange('phone', e.target.value)}
            onFocus={() => handleFocus('phone')}
            onBlur={() => handleBlur('phone')}
          >
            {(inputProps) => (
              <input
                {...inputProps}
                type="tel"
                className="google-review-input"
                placeholder={!showLabel ? placeholder : ''}
            style={{
            ...styles.input,
            borderColor: errors[field] ? '#ccc' : '#ccc',
          }}
              />
            )}
          </InputMask>
        ) : (
          <input
            type={type}
            value={fields[field]}
            className="google-review-input"
            placeholder={!showLabel ? placeholder : ''}
            onFocus={() => handleFocus(field)}
            onBlur={() => handleBlur(field)}
            onChange={(e) => handleChange(field, e.target.value)}
                      style={{
            ...styles.input,
            borderColor: errors[field] ? '#ccc' : '#ccc',
          }}
          />
        )}

        {showLabel && (
          <label
            style={{
              ...styles.label,
              top: '-5px',
              fontSize: 12,
              transform: 'translateY(0)',
              color: '#637381',
              fontStyle: 'normal',
              fontWeight: 450,
            }}
          >
            {label}
          </label>
        )}
        {errors[field] && <div style={styles.errorText}>{errors[field]}</div>}
      </div>
    );
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <button style={styles.closeButton} onClick={onClose}>
          &times;
        </button>

        <div style={styles.header}>
          <h2 style={styles.title}>
            Request Google Review
            <img
              src="https://www.google.com/favicon.ico"
              alt="Google"
              style={styles.googleIcon}
            />
          </h2>
        </div>

        {renderFloatingInput('email', 'Customer Email', 'Enter Customer Email', 'email')}
        {renderFloatingInput('phone', 'Customer Mobile Phone', 'Enter Customer Mobile Phone', 'tel')}
        {renderFloatingInput('firstName', 'First name', 'First name (Optional)')}
        {renderFloatingInput('lastName', 'Last name', 'Last name (Optional)')}

        <div style={styles.footer}>
          <button style={styles.cancelButton} onClick={onClose}>
            Close
          </button>
          <button
            style={isFormValid ? styles.submitButton : styles.disableSubmitButton}
            onClick={handleSubmit}
          >
            Send SMS Request
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    zIndex: 1000,
  },
  popup: {
    backgroundColor: 'white',
    padding: '24px',
    borderRadius: '12px',
    width: '600px',
    maxHeight: '90vh',
    overflowY: 'auto',
    position: 'relative',
    fontFamily: 'Arial, sans-serif',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    boxSizing: 'border-box',
  },
  closeButton: {
    position: 'absolute',
    top: '15px',
    right: '15px',
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    lineHeight: '1',
  },
  header: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    margin: 0,
    color: "#212B36"
  },
  googleIcon: {
    width: '18px',
    height: '18px',
  },
  inputWrapper: {
    position: 'relative',
    marginBottom: '24px',
    width: '100%',
  },
  input: {
    width: '100%',
    padding: '18px 16px 16px 16px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '1px solid #919EAB',
    boxSizing: 'border-box',
    backgroundColor: 'white',
    lineHeight: '1.2',
  },
  label: {
    position: 'absolute',
    left: '16px',
    transition: 'all 0.2s ease',
    backgroundColor: 'white',
    padding: '0 4px',
    pointerEvents: 'none',
    lineHeight: '1',
  },
  errorText: {
    fontSize: '12px',
    color: 'red',
    marginTop: '4px',
    paddingLeft: '4px',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    marginTop: '20px',
  },
  cancelButton: {
    padding: '10px 20px',
    backgroundColor: 'white',
    border: '1px solid #ccc',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 700,
  },
  submitButton: {
    padding: '10px 20px',
    backgroundColor: '#212B36',
    border: 'none',
    color: 'white',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  disableSubmitButton: {
    padding: '10px 20px',
    color: '#919EABCC',
    border: 'none',
    backgroundColor: '#919EAB3D',
    borderRadius: '6px',
    cursor: 'not-allowed',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '14px',
    fontWeight: 700,
  },
};
